import React, { useState, useEffect, useRef } from "react";
import { BsThreeDotsVertical, BsDownload } from "react-icons/bs";
import Layout from "../layout/Layout";
import Line from "../assets/img/Line.png";
import { GoSearch } from "react-icons/go";
import { FcOpenedFolder } from "react-icons/fc";
import { IoMdAddCircleOutline } from "react-icons/io";
import { VscEye } from "react-icons/vsc";
import { HiOutlineDownload } from "react-icons/hi";
import { BiEditAlt, BiLink, BiUserPlus } from "react-icons/bi";
import { MdOutlineDriveFileMove, MdDelete } from "react-icons/md";

import {
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
  Button,
} from "@material-tailwind/react";
import { Link } from "react-router-dom";

const Toggle = () => {
  return (
    <div className="fixed top-0 left-[0%] z-[9999999999999] w-full h-full   grid place-items-center place-content-center ">
      <div className="h-auto sm:max-w-[470px] filter-screen-model outline-none bg-white rounded-lg shadow-2xl mx-5">
        <div className="origin-top-left absolute right-0 mt-2 mr-28 w-48 rounded-[10px] shadow-lg bg-white ring-1 ring-black ring-opacity-5">
          <div
            className="py-1"
            role="menu"
            aria-orientation="vertical"
            aria-labelledby="options-menu"
          >
            <li className="block px-4 py-2 text-sm text-gray-700 cursor-pointer">
              <div className="flex items-center gap-2">
                <VscEye size={23} /> Preview
              </div>
            </li>
            <hr />
            <li className="block px-4 py-2 text-sm text-gray-700 cursor-pointer">
              <div className="flex items-center gap-2">
                <HiOutlineDownload size={23} /> Download
              </div>
            </li>
            <li className="block px-4 py-2 text-sm text-gray-700 cursor-pointer">
              <div className="flex items-center gap-2">
                <BiEditAlt size={23} /> Rename
              </div>
            </li>
            <li className="block px-4 py-2 text-sm text-gray-700 cursor-pointer">
              <div className="flex items-center gap-2">
                <BiLink size={23} /> Make a copy
              </div>
            </li>
            <li className="block px-4 py-2 text-sm text-gray-700 cursor-pointer">
              <div className="flex items-center gap-2">
                <BiUserPlus size={23} /> Share
              </div>
            </li>

            <li className="block px-4 py-2 text-sm text-gray-700 cursor-pointer">
              <div className="flex items-center gap-2">
                <MdOutlineDriveFileMove size={23} /> Move
              </div>
            </li>
            <hr />
            <li className="block px-4 py-2 text-sm text-gray-700 cursor-pointer">
              <div className="flex items-center gap-2 ">
                <MdDelete size={23} /> Delete
              </div>
            </li>
          </div>
        </div>
      </div>
    </div>
  );
};
const Download = () => {
  const [showInput, setShowInput] = useState(false);
  const [folderName, setFolderName] = useState("");
  const [folders, setFolders] = useState([]);

  const handleClick = () => {
    setShowInput(true);
  };

  const handleInputChange = (event) => {
    setFolderName(event.target.value);
  };

  useEffect(() => {
    // Load the folders from local storage when the component mounts
    const storedFolders = localStorage.getItem("folder");
    if (storedFolders) {
      setFolders(JSON.parse(storedFolders));
    }
  }, []);

  const handleCreateFolder = () => {
    // Create a new folder object with name and date properties
    const newFolder = {
      name: folderName,
    };

    // Update folders state with the new folder
    setFolders((prevFolders) => [newFolder, ...prevFolders]);

    // Reset input and hide it
    setFolderName("");
    setShowInput(false);

    localStorage.setItem("folder", JSON.stringify([...folders, newFolder]));
  };

  //////////////////////////////////////////

  const [popup, setPopup] = useState(false);
  const dropdownRef = useRef(null);
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setPopup(false);
    }
  };
  useEffect(() => {
    window.addEventListener("mousedown", handleClickOutside);

    return () => {
      window.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <Layout>
      <div className="container">
        <div className="md:flex justify-between lg:my-10 my-3">
          <div className="flex lg:text-[30px] text-[20px] font-semibold gap-3 justify-center items-center">
            <img src={Line} alt="" className="h-7" />
            <h1 className="text-[#22345C]">Download</h1>
          </div>
          <div class="relative">
            <input
              class="shadow-md pl-10  rounded-lg lg:w-96 text-[#9F9F9F] text-[16px] py-2 px-3  focus:outline-none"
              id="username"
              type="text"
              placeholder="Search"
            />

            <div class="absolute left-0 inset-y-0 flex py-2 ">
              <GoSearch size={20} className="ml-3 text-[#22345C]" />
            </div>
          </div>
        </div>

        <div className="">
          {/* <div className="flex gap-2 items-center mx-2 my-3 ">
            <IoMdAddCircleOutline size={26} className="text-[#22345C]" />
            <p className="font-sans text-xl font-medium text-[#565656]">
              New Folder
            </p>
          </div> */}
          {showInput ? (
            <div className="flex items-center space-x-2">
              <input
                type="text"
                value={folderName}
                onChange={handleInputChange}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleCreateFolder();
                  }
                }}
                className="border outline-none border-gray-300 rounded-lg px-2 py-1"
                placeholder="Enter folder name"
              />
              {/* <button
                onClick={handleCreateFolder}
                className="bg-[#FF0101] text-white px-4 py-1 rounded-lg"
              >
                Create Folder
              </button> */}
            </div>
          ) : (
            <button
              onClick={handleClick}
              className="px-2 py-2 text-base flex w-40 mb-5  items-center mx-2 cursor-pointer bg-white rounded-[10px] border-gray-400"
            >
              <IoMdAddCircleOutline size={26} className="text-[#22345C]" />
              <p className="font-sans ml-2 text-xl font-medium text-[#3F3F3F]">
                New Folder
              </p>
            </button>
          )}
        </div>

        <div>
          <div className="text-[#6F6F6F] font-medium font-sans text-xl mt-10">
            Folders
          </div>
          <div className="grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-5 mt-5">
            <div className="flex justify-between items-center bg-white p-5 rounded-[10px] border-gray-400">
              <div className="flex gap-2 items-center">
                <FcOpenedFolder size={25} />
                <p className="font-sans font-medium text-[#565656]">Folder A</p>
              </div>
              <BsThreeDotsVertical
                size={20}
                className="text-[#565656] cursor-pointer"
              />
            </div>
            <div className="flex justify-between items-center bg-white p-5 rounded-[10px] border-gray-400">
              <div className="flex gap-2 items-center">
                <FcOpenedFolder size={25} />
                <p className="font-sans font-medium text-[#565656]">Folder B</p>
              </div>
              <BsThreeDotsVertical
                size={20}
                className="text-[#565656] cursor-pointer"
              />
            </div>
            <div className="flex justify-between items-center bg-white p-5 rounded-[10px] border-gray-400">
              <div className="flex gap-2 items-center">
                <FcOpenedFolder size={25} />
                <p className="font-sans font-medium text-[#565656]">Folder C</p>
              </div>
              <BsThreeDotsVertical
                size={20}
                className="text-[#565656] cursor-pointer"
              />
            </div>
            {folders.map((folder, index) => (
              <>
                <div
                  key={index}
                  className="flex justify-between items-center bg-white p-5 rounded-[10px] border-gray-400"
                >
                  <div className="flex gap-2 items-center">
                    <FcOpenedFolder size={25} />
                    <p className="font-sans font-medium text-[#565656]">
                      {folder.name}
                    </p>
                  </div>
                  <BsThreeDotsVertical
                    size={20}
                    className="text-[#565656] cursor-pointer"
                  />
                </div>
              </>
            ))}
            {/* <div className="flex justify-between items-center bg-white p-5 rounded-[10px] border-gray-400">
              <div className="flex gap-2 items-center">
                <FcOpenedFolder size={25} />
                <p className="font-sans font-medium text-[#565656]">Folder A</p>
              </div>
              <BsThreeDotsVertical
                size={20}
                className="text-[#565656] cursor-pointer"
              />
            </div>
            <div className="flex justify-between items-center bg-white p-5 rounded-[10px] border-gray-400">
              <div className="flex gap-2 items-center">
                <FcOpenedFolder size={25} />
                <p className="font-sans font-medium text-[#565656]">Folder B</p>
              </div>
              <BsThreeDotsVertical
                size={20}
                className="text-[#565656] cursor-pointer"
              />
            </div>
            <div className="flex justify-between items-center bg-white p-5 rounded-[10px] border-gray-400">
              <div className="flex gap-2 items-center">
                <FcOpenedFolder size={25} />
                <p className="font-sans font-medium text-[#565656]">Folder C</p>
              </div>
              <BsThreeDotsVertical
                size={20}
                className="text-[#565656] cursor-pointer"
              />
            </div> */}
          </div>
          <div className="overflow-auto lg:overflow-visible mt-16">
            <table className="table w-full text-gray-400 border-separate space-y-6">
              <thead className="bg-[#22345C] text-white lg:text-xl">
                <tr>
                  <th className="p-3 text-left ">Document Name</th>
                  <th className="p-3 text-left">Version</th>
                  <th className="p-3 text-left">Date Created</th>
                  <th className="p-3 text-left">Created By</th>
                  <th className="p-3 text-left">Changes / Notes</th>
                  <th className="p-3 text-center">Option</th>
                </tr>
              </thead>
              <tbody>
                <tr className="bg-[#F5F7FD] lg:text-black font-bold font-sans text-lg">
                  <td className="p-3">Document A</td>
                  <td className="p-3">1.3</td>
                  <td className="p-3">2023-08-15</td>
                  <td className="p-3 ">Admin</td>
                  <td className="p-3">Initial Version </td>

                  <td className="p-3 ">
                    <div
                      onClick={() => setPopup(true)}
                      className="relative flex items-center justify-center"
                      ref={dropdownRef}
                    >
                      <BsThreeDotsVertical
                        size={20}
                        className="cursor-pointer"
                      />
                    </div>
                    {popup ? Toggle() : ""}
                  </td>
                </tr>
                <tr className="bg-[#F5F7FD] lg:text-black font-bold font-sans text-lg">
                  <td className="p-3">Intake Form</td>
                  <td className="p-3">1.3</td>
                  <td className="p-3">2023-08-25</td>
                  <td className="p-3 ">Admin</td>
                  <td className="p-3">
                    Revised formatting and corrected types
                  </td>

                  <td className="p-3 ">
                    <div
                      onClick={() => setPopup(true)}
                      ref={dropdownRef}
                      className="flex items-center justify-center"
                    >
                      <BsThreeDotsVertical
                        onClick={Toggle}
                        size={20}
                        className="cursor-pointer"
                      />
                    </div>
                    {popup ? Toggle() : ""}
                  </td>
                </tr>
                <tr className="bg-[#F5F7FD] lg:text-black font-bold font-sans text-lg rounded-xl">
                  <td className="p-3">Intake Form</td>
                  <td className="p-3">1.3</td>
                  <td className="p-3">2023-08-20</td>
                  <td className="p-3 ">User</td>
                  <td className="p-3">Updated introduction section</td>

                  <td className="p-3 ">
                    <div
                      onClick={() => setPopup(true)}
                      ref={dropdownRef}
                      className="flex items-center justify-center"
                    >
                      <BsThreeDotsVertical
                        onClick={Toggle}
                        size={20}
                        className="cursor-pointer"
                      />
                    </div>
                    {popup ? Toggle() : ""}
                  </td>
                </tr>
                <tr className="bg-[#F5F7FD] lg:text-black font-bold font-sans text-lg">
                  <td className="p-3">Intake Form</td>
                  <td className="p-3">1.3</td>
                  <td className="p-3">2023-08-20</td>
                  <td className="p-3 ">Team</td>
                  <td className="p-3">Updated Documents </td>
                  <td className="p-3 ">
                    <div
                      onClick={() => setPopup(true)}
                      ref={dropdownRef}
                      className="flex items-center justify-center"
                    >
                      <BsThreeDotsVertical
                        onClick={Toggle}
                        size={20}
                        className="cursor-pointer"
                      />
                    </div>
                    {popup ? Toggle() : ""}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div>
          <style
            dangerouslySetInnerHTML={{
              __html:
                "\n\n    .table {\n    border-spacing: 0 15px;\n  }\n\n  i {\n    font-size: 1rem !important;\n  }\n\n  .table tr {\n    border-radius: 20px;\n  }\n\n  tr td:nth-child(n + 6),\n  tr th:nth-child(n + 6) {\n    border-radius: 0 0.625rem 0.625rem 0;\n  }\n\n  tr td:nth-child(1),\n  tr th:nth-child(1) {\n    border-radius: 0.625rem 0 0 0.625rem;\n  }\n\n",
            }}
          />

          <link
            href="https://fonts.googleapis.com/css?family=Material+Icons|Material+Icons+Outlined|Material+Icons+Two+Tone|Material+Icons+Round|Material+Icons+Sharp"
            rel="stylesheet"
          />
        </div>
      </div>
    </Layout>
  );
};

export default Download;
